const FORCED_AUTHENTICATION = process.env.REACT_APP_FORCED_AUTHENTICATION === "true"
const OSU_NAV_ID = 'osu-navbar'
const MAIN_ID = 'page-content'
const ACCESSIBLE_REFLOW_HEIGHT = `399px`
const TOC_WIDTH = `15rem`
const NAVBAR_WRAPPER_ID = "app-header"
const STATUSES = {
    IDLE: "idle",
    LOADING: "loading",
    CLEARING: "clearing",
    ERROR: "error",
    SUCCESS: "success",
    CLEARED: "cleared",
    UNAUTH: "unauth",
    COGNITO_FAILURE: "COGNITO_FAILURE",
}
const APPLICATION_NAME = (process.env.APPLICATION_NAME) || 'Reporting Foreign Gifts and Contracts'
const ROLES = {
    USERS: 'FOREIGN-GIFTS-USERS',
    ADMINS: 'FOREIGN-GIFTS-ADMIN',
}
const DARK_MODE_CLASSNAME = 'dark-mode-enabled'
const FORM_STATUSES = {
    DRAFT: 'DRAFT',
    SUBMITTED: 'SUBMITTED',
    ACCEPTED: 'ACCEPTED',
    REPORTED: 'REPORTED',
    REPORTED_ED_1: 'REPORTED_ED_1',
    REPORTED_ED_2: 'REPORTED_ED_2',
    DELETED: 'DELETED',
    UNSAVED: 'UNSAVED',
}
const FORM_STATUS_LABELS = {
    [FORM_STATUSES.DRAFT]: 'Draft',
    [FORM_STATUSES.SUBMITTED]: 'Submitted by Unit',
    [FORM_STATUSES.ACCEPTED]: 'Accepted',
    [FORM_STATUSES.REPORTED]: 'Reported to ED',
    [FORM_STATUSES.REPORTED_ED_1]: 'Reported to ED 1',
    [FORM_STATUSES.REPORTED_ED_2]: 'Reported to ED 2',
    [FORM_STATUSES.DELETED]: 'Deleted',
    [FORM_STATUSES.UNSAVED]: 'Not Yet Saved',
}

const FORM_STATUS_COLORS = {
    [FORM_STATUSES.DRAFT]: 'yellow',
    [FORM_STATUSES.SUBMITTED]: 'blue',
    [FORM_STATUSES.ACCEPTED]: 'green',
    [FORM_STATUSES.REPORTED]: 'green',
    [FORM_STATUSES.REPORTED_ED_1]: 'green',
    [FORM_STATUSES.REPORTED_ED_2]: 'green',
    [FORM_STATUSES.DELETED]: 'red',
    [FORM_STATUSES.UNSAVED]: 'gray',
}

export const SESSION_KINDS = {
    FGC: 'FGC',
    SCHEMA: "SCHEMA"
}

export const RTK_STATUSES = {
    uninitialized: 'uninitialized',
    pending: 'pending',
    fulfilled: 'fulfilled',
    uncaught: 'uncaught',
}

const ALERT_SEVERITY = {
    ERROR: 'error',
    INFO: 'info',
    SUCCESS: 'success',
    WARNING: 'warning',
}

export {
    FORCED_AUTHENTICATION,
    OSU_NAV_ID,
    MAIN_ID,
    ACCESSIBLE_REFLOW_HEIGHT,
    TOC_WIDTH,
    NAVBAR_WRAPPER_ID,
    STATUSES,
    APPLICATION_NAME,
    ROLES,
    DARK_MODE_CLASSNAME,
    FORM_STATUSES,
    FORM_STATUS_LABELS,
    FORM_STATUS_COLORS,
    ALERT_SEVERITY
}